import React from 'react';

import { OmaLummeApp } from '../../omaLummeContext';

import Loading from '../Common/Loading';
//Actions.
import { oidcAuth } from '../../actions';
// Types.
import { CurrentUserProps } from '../../types/customer';
// Utils.
import { setUserDetails, inIframe } from '../../utils/login';

const Login: React.FunctionComponent<CurrentUserProps> = (props: CurrentUserProps) => {
  const dispatch = OmaLummeApp.useDispatch();

  const { users } = OmaLummeApp.useState();

  const [userCode, setUserCode] = React.useState('');
  const [userLoggingIn, setUserLoggingIn] = React.useState(false);
  const { userHasToken, setUserHasToken } = props;

  React.useEffect(() => {
    async function logUserIn(code: string): Promise<void> {
      const isIframe = inIframe();
      const userDetails = await oidcAuth(code, isIframe);

      if (userDetails) {
        if (userDetails.id_token) {
          sessionStorage.setItem('keycloakIdToken', userDetails.id_token);
        }
        if (userDetails.token && !isNaN(userDetails.customerId)) {
          const newUsers = await setUserDetails(userDetails, users);
          dispatch(['changeUsers', newUsers]);
          sessionStorage.setItem('token', userDetails.token);
          setUserHasToken(true);

          const uri = window.location.toString();
          if (uri.indexOf('?') > 0) {
            const cleanUri = uri.substring(0, uri.indexOf('?'));
            window.history.replaceState({}, document.title, cleanUri);
          }
          window.top?.location.reload();
        }
      }
    }

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const param = params.get('code');
    const csrf = params.get('state');

    if (param && csrf === sessionStorage.getItem('csrf') && !userLoggingIn) {
      // log user in.
      setUserLoggingIn(true);
      logUserIn(param);
    }
  }, [userCode, userLoggingIn, setUserLoggingIn, setUserHasToken]);

  React.useEffect(() => {
    // We check if the user has a token stored in sessionStorage and if there is we validate it.
    const token = sessionStorage.getItem('token');
    if (token) {
      setUserHasToken(true);
    }
  }, [userHasToken, setUserHasToken]);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const param = params.get('code');
  if (param && !userCode) {
    setUserCode(param);
  }

  return <div className="login">{<Loading />}</div>;
};

export default Login;
